if (!customElements.get('athlete-articles')) {
  customElements.define(
    'athlete-articles',
    class AthleteArticles extends SliderComponent {
      constructor() {
        super();

        this.state = {
          articles_token: null,
          athlete_id: null,
          fetched_articles: null,
          athlete_articles: null,
        };

        this.storeUrl = window.Shopify.shop;
        this.articlesQuery = `query BlogArticles($first: Int!, $cursor: String) {
            articles(first: $first, after: $cursor, sortKey: PUBLISHED_AT, reverse: true) {
              nodes {
                image {
                  url
                  altText
                }
                publishedAt
                title
                excerpt
                content(truncateAt: 200)
                handle
                blog {
                  handle
                }
                featured_athletes: metafield(key: "featured_athletes", namespace: "yonex") {
                  value
                  references(first: 10) {
                    nodes {
                      ... on Metaobject {
                        id
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
                hasPreviousPage
                startCursor
              }
            }
          }`;

        this.receiveAccessTokenAndVariant();
      }

      setState(key, value) {
        if (!Object.keys(this.state).includes(key)) return;
        this.state[key] = value;
        const event = new Event(`state.${this.id}.${key}`);
        document.dispatchEvent(event);
      }

      formatDate = (dateString) => {
        const date = new Date(dateString); // Create Date object from the string

        // Extract the month, day, and year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month, pad to 2 digits
        const day = date.getDate().toString().padStart(2, '0'); // Pad day to 2 digits
        const year = date.getFullYear();

        // Return the formatted date in the desired format (mm.dd.yyyy)
        return `${month}.${day}.${year}`;
      };

      renderArticles = () => {
        const { athlete_articles } = this.state; // Get the list of articles
        const sectionId = this.getAttribute('data-section-id');
        const showImage = this.getAttribute('data-show-image') === 'true';
        const showDate = this.getAttribute('data-show-date') === 'true';
        const containerDiv = document.getElementById(`Slider-${sectionId}`);

        if (athlete_articles.length) {
          // Loop through and generate the next li items
          for (let i = 0; i < athlete_articles.length; i++) {
            const article = athlete_articles[i];

            const li = document.createElement('li');
            li.className =
              'blog__post grid__item article slider__slide slider__slide--full-width scroll-trigger animate--slide-in';
            li.id = `Slide-${sectionId}-${i + 1}`;
            li.setAttribute('data-cascade', '');
            li.style.setProperty('--animation-order', i);

            const articleCardWrapper = document.createElement('div');
            articleCardWrapper.className = 'article-card-wrapper card-wrapper';

            const card = document.createElement('div');
            card.className = 'card article-card card--standard card--media';
            card.style.setProperty('--ratio-percent', '60.24096385542169%');

            const cardInner = document.createElement('div');
            cardInner.className = 'card__inner color-scheme-2 gradient ratio';
            cardInner.style.setProperty('--ratio-percent', '60.24096385542169%');

            const articleCardImageWrapper = document.createElement('div');
            articleCardImageWrapper.className = 'article-card__image-wrapper card__media';

            const articleCardImage = document.createElement('div');
            articleCardImage.className = 'article-card__image media media--hover-effect';

            const imageLink = document.createElement('a');
            imageLink.href = `/blogs/${article.blog.handle}/${article.handle}`;

            const img = document.createElement('img');
            img.src = article.image.url;
            img.alt = article.image.altText ?? article.title;
            img.className = 'motion-reduce';
            img.loading = 'lazy';

            imageLink.appendChild(img);
            articleCardImage.appendChild(imageLink);
            if (showImage) {
              articleCardImageWrapper.appendChild(articleCardImage);
            }
            cardInner.appendChild(articleCardImageWrapper);

            const cardContent = document.createElement('div');
            cardContent.className = 'card__content';
            const cardInformation = document.createElement('div');
            cardInformation.className = 'card__information';

            const articleContent = document.createElement('div');
            articleContent.className = 'article-card__info caption-with-letter-spacing';
            const dateP = document.createElement('p');
            dateP.className = 'circle-divider';
            dateP.textContent = this.formatDate(article.publishedAt);

            if (showDate) {
              articleContent.appendChild(dateP);
            }
            const articleLink = document.createElement('a');
            articleLink.className = 'article-card__info-link';
            articleLink.href = `/blogs/${article.blog.handle}/${article.handle}`;

            const articleHeading = document.createElement('h3');
            articleHeading.className = 'card__heading h4';
            articleHeading.textContent = article.title;

            articleLink.appendChild(articleHeading);

            const excerptP = document.createElement('p');
            excerptP.className = 'article-card__excerpt rte-width';
            excerptP.textContent = article.excerpt != '' ? article.excerpt : article.content;

            cardInformation.appendChild(articleContent);
            cardInformation.appendChild(articleLink);
            cardInformation.appendChild(excerptP);

            const footerDiv = document.createElement('div');
            footerDiv.className = 'article-card__footer';
            cardInformation.appendChild(footerDiv);

            const readMoreLink = document.createElement('a');
            readMoreLink.className = 'button button--secondary';
            readMoreLink.href = `/blogs/${article.blog.handle}/${article.handle}`;
            readMoreLink.textContent = 'Read more';
            cardInformation.appendChild(readMoreLink);

            cardContent.appendChild(cardInformation);

            card.appendChild(cardInner);
            card.appendChild(cardContent);
            articleCardWrapper.appendChild(card);
            li.appendChild(articleCardWrapper);

            containerDiv.appendChild(li);
          }

          // Create slideshow control wrapper with the correct number of buttons
          const slideshowControlWrapper = document.querySelector(
            `.featured-articles-${sectionId} .slider-counter .slideshow__control-wrapper`,
          );
          slideshowControlWrapper.innerHTML = ``;

          const numSlides = athlete_articles.length;

          // Create buttons for each slide
          for (let i = 0; i < numSlides; i++) {
            const button = document.createElement('button');
            button.className =
              i === 0
                ? 'slider-counter__link slider-counter__link--dots link slider-counter__link--active'
                : 'slider-counter__link slider-counter__link--dots link';
            button.setAttribute('aria-label', `Load slide ${i + 1} of ${numSlides}`);
            button.setAttribute('aria-controls', `Slider-${sectionId}`);
            button.style.display = 'inline-block';

            if (i === 0) {
              button.setAttribute('aria-current', 'true');
            }

            const dot = document.createElement('span');
            dot.className = 'dot';

            button.appendChild(dot);
            slideshowControlWrapper.appendChild(button);
          }
        }

        // Initialize the slider functionality
        this.initializeSlider(sectionId, athlete_articles.length);
      };

      initializeSlider = (sectionId, numSlides) => {
        if (numSlides === 0) {
          document.querySelector(`.featured-articles-${sectionId}`).style.display = 'none';
        }

        if (numSlides < 3) {
          document
            .querySelector(`.featured-articles-${sectionId} .featured-articles__wrapper`)
            .classList.add('page-width-tablet');
        }

        if (numSlides > 2) {
          document.getElementById(`Slider-${sectionId}`).classList.add('slider--tablet');
        } else {
          document.getElementById(`Slider-${sectionId}`).classList.add('slider--mobile');
        }

        const columnsDesktop = parseInt(this.getAttribute('data-columns-desktop'), 10);
        if (numSlides > columnsDesktop) {
          document.getElementById(`Slider-${sectionId}`).classList.add('slider--desktop');
        }

        const sliderButtons = document.querySelector(`.featured-articles-${sectionId} .slider-buttons `);
        if (numSlides <= columnsDesktop) {
          sliderButtons.classList.add('large-up-hide');
        }
        if (numSlides < 3) {
          sliderButtons.classList.add('medium-hide');
        }
        if (numSlides < 2) {
          sliderButtons.classList.add('small-hide');
        }

        const slideshowCounterTotal = document.querySelector(
          `.featured-articles-${sectionId} .slider-counter .slider-counter__dots_counter .slider-counter--total`,
        );
        slideshowCounterTotal.textContent = numSlides < 10 ? `0${numSlides}` : numSlides;

        const sliderContainer = document.querySelector(`.featured-articles-${sectionId} slider-component`);

        this.sliderControlButtons = sliderContainer.querySelectorAll('.slider-counter__link');
        this.slider = sliderContainer.querySelector('[id^="Slider-"]');
        this.sliderItems = sliderContainer.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = sliderContainer.querySelector('.slider-counter--current');
        this.pageTotalElement = sliderContainer.querySelector('.slider-counter--total');
        this.prevButton = sliderContainer.querySelector('button[name="previous"]');
        this.nextButton = sliderContainer.querySelector('button[name="next"]');

        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.round(this.slider.clientWidth / this.sliderItemOffset);
        this.totalPages = Math.max(this.sliderItemsToShow.length - this.slidesPerPage + 1, 1);

        this.initPages();

        const resizeObserver = new ResizeObserver((entries) => {
          this.initPages();
          this.updateArrowPosition();
        });
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

        this.sliderControlWrapper = sliderContainer.querySelector('.slider-buttons');

        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));

        this.updateArrowPosition();
      };

      filterArticles = () => {
        const { fetched_articles, athlete_id } = this.state;
        const articlesLimit = parseInt(this.getAttribute('data-articles-limit'), 10); // Get limit value

        const athleteArticles = fetched_articles.filter((article) => {
          // Check if any athlete in the article's featured_athletes references matches the given athleteId
          return article?.featured_athletes?.references?.nodes?.some(
            (node) => node.id === `gid://shopify/Metaobject/${athlete_id}`,
          );
        });

        // Apply the limit if it is a valid number
        const limitedArticles = articlesLimit > 0 ? athleteArticles.slice(0, articlesLimit) : athleteArticles;

        this.setState('athlete_articles', limitedArticles);
        this.renderArticles();
      };

      fetchArticlesQuery = async () => {
        const variables = {
          first: 250,
          cursor: null,
        };

        let hasNextPage = true;
        let allArticles = [];

        while (hasNextPage) {
          // Include the cursor in variables
          if (variables.cursor) {
            variables.cursor = variables.cursor;
          }

          const articlesOptionsQuery = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.state.articles_token,
            },
            body: JSON.stringify({
              query: this.articlesQuery,
              variables,
            }),
          };

          try {
            const response = await fetch(`https://${this.storeUrl}/api/2023-10/graphql`, articlesOptionsQuery);
            const result = await response.json();

            if (result.errors) {
              console.error('GraphQL error:', result.errors);
              // Handle GraphQL errors as needed
              return;
            }

            const { nodes, pageInfo } = result.data.articles;

            if (nodes && nodes.length > 0) {
              allArticles = [...allArticles, ...nodes];
            }

            if (pageInfo && pageInfo.hasNextPage) {
              variables.cursor = pageInfo.endCursor;
            } else {
              hasNextPage = false;
            }
          } catch (error) {
            console.error('Error fetching articles:', error);
            // Handle error as needed
            return;
          }
        }

        this.setState('fetched_articles', allArticles);
        this.filterArticles();
      };

      receiveAccessTokenAndVariant() {
        const token = this.getAttribute('data-articles-token');
        const athleteId = this.getAttribute('data-athlete-id');

        if (token && athleteId) {
          this.setState('articles_token', token);
          this.setState('athlete_id', athleteId);

          this.fetchArticlesQuery();
        }
      }
    },
  );
}
